<template>
	<nta-dialog
		:show="props.modal.show"
		height="auto"
		:title="symbolsStore.GUILabel('e385a300-27b6-4c3e-ba0b-ef63b9b7974c')"
		:symbol-lang="domainStore.languagePreference"
		@close="() => denie()"
	>
		<template #actions>
			<v-btn color="error" @click="denie"> {{ props.denieLabel || defaultDenieLabel }} </v-btn>
			<v-btn color="success" @click="grant"> {{ props.grantLabel || defaultGrantLabel }} </v-btn>
		</template>
		<template #default>
			<v-card-text>
				<div>{{ props.modal.message }}</div>
			</v-card-text>
		</template>
	</nta-dialog>
</template>

<script setup lang="ts">
import { useSymbolsStore } from "../store/symbols";
import { useDomainStore } from "../store/domain";
import { ref } from "vue";

const symbolsStore = useSymbolsStore();
const domainStore = useDomainStore();

const props = defineProps({
	modal: {
		type: Object,
		default: () => ({
			show: false,
			message: "",
			data: {},
		}),
	},
	denieLabel: {
		type: String,
		default: "",
	},
	grantLabel: {
		type: String,
		default: "",
	},
});
const emits = defineEmits(["confirmation", "done"]);
const defaultDenieLabel = ref(symbolsStore.GUILabel("e2aeee56-2d85-4bc9-b825-687cde5a93b1"));
const defaultGrantLabel = ref(symbolsStore.GUILabel("6afa811b-3077-4346-825b-25402b59a1a2"));

function denie() {
	emits("confirmation", false, props.modal.data);
	emits("done");
}
function grant() {
	emits("confirmation", true, props.modal.data);
	emits("done");
}
</script>

<style></style>
